<template>
  <div class="ai-response-agent">
    <slot name="agent-icon">
      <img
        :src="img || defaultAgentImage"
        :alt="name"
        class="ai-response-agent__icon"
        :class="{ 'ai-response-agent__icon--border': addAvatarBorder }"
      />
    </slot>
    <slot name="agent-name">
      <BaseSubHeading
        size="large"
        weight="500"
        color="monochrome-07"
        class="ai-response-agent__name"
      >
        {{ name }}
      </BaseSubHeading>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useStore } from "vuex"

import BaseSubHeading from "@/components/Base/BaseSubHeading.vue"

import { Getters } from "@/store"

defineProps({
  name: {
    type: String,
    default: ""
  },
  img: {
    type: String,
    default: ""
  },
  addAvatarBorder: {
    type: Boolean,
    default: false
  }
})

const store = useStore()

const defaultAgentImage = computed(() =>
  store.getters[Getters.THEME_IS_DARK]
    ? require("@/assets/images/ai-agent.dark.png")
    : require("@/assets/images/ai-agent.png")
)
</script>
